import { render, staticRenderFns } from "./CalcularCalificaciones.vue?vue&type=template&id=7b6fc1c2&"
import script from "./CalcularCalificaciones.vue?vue&type=script&lang=js&"
export * from "./CalcularCalificaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports